"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createInputMarkdownEditor = exports.InputMarkdownEditor = exports.InputMarkdownEditorComponent = exports.InputMarkdownEditorDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var field_container_1 = require("../elements/field-container");
var form_field_id_1 = require("../../utils/form-field-id");
var use_modal_1 = require("../../hooks/use-modal");
var entity_embed_dialog_1 = require("../entities/entity-embed-dialog");
var react_simplemde_editor_1 = __importDefault(require("react-simplemde-editor"));
require("easymde/dist/easymde.min.css");
var icon_label_1 = require("../elements/icon-label");
var use_lang_1 = require("../../hooks/use-lang");
var icons_1 = require("../icons");
var entity_completion_dialog_1 = require("../entities/entity-completion-dialog");
var use_entities_1 = require("../../hooks/use-entities");
var entity_modal_form_route_1 = require("../entities/entity-modal-form-route");
var link_dialog_1 = require("../entities/link-dialog");
exports.InputMarkdownEditorDefaultProps = {
  variant: 'border',
  options: {
    indentWithTabs: false,
    minHeight: '150px',
    spellChecker: false
  }
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    \n    .icon {\n      font-size: 18px;\n      position: relative;\n      top: 3px;\n    }\n\n    .CodeMirror-fullscreen {\n      z-index: 500 !important;\n    }\n\n  "], ["\n    \n    .icon {\n      font-size: 18px;\n      position: relative;\n      top: 3px;\n    }\n\n    .CodeMirror-fullscreen {\n      z-index: 500 !important;\n    }\n\n  "])))
});
var EditorContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\n    position: relative;\n\n    ", "\n\n    &:focus-within {\n      .CodeMirror-wrap {\n        border-color: ", ";\n      }\n\n    }\n    .editor-statusbar {\n      border: 1px solid #DDD;\n      border-top: 0;\n      background: #F9F9F9;\n    }\n\n    .editor-preview-side {\n      z-index: 200;\n      border-right: none;\n      border-left-color: #D2D2D2;\n      border-top-color: #D2D2D2;\n    }\n\n    .editor-toolbar.fullscreen {\n      z-index: 200;\n      padding: ", " ", " 0 ", ";\n      background: ", ";\n    }\n\n    .editor-toolbar {\n      border: none;\n      padding: 0;\n      margin-bottom: 4px;\n      &:before {\n        margin-bottom: 0px;\n        height: 0;\n      }\n\n      button {\n        border-radius: 0;\n      }\n      \n      button.active,\n      button.hover,\n      button:focus,\n      button:active { \n        border-color: ", ";\n        outline-color: ", ";\n      }\n\n      &.disabled-for-preview {\n        button {\n          opacity: 0.1;\n        }\n\n        button.preview, button.guide {\n          opacity: 1.0;\n        }\n      }\n    }\n\n    .editor-preview {\n      padding: 14px;\n      line-height: 1.5em;\n      a {\n        color: ", ";\n        font-weight: 400;\n        text-decoration: none;\n      }\n\n      h1, h2, h3, h4, h5 {\n        margin-top: 0em;\n        margin-bottom: 0.5em;\n        line-height: 1.35em;\n        font-weight: 500;\n        color: ", ";\n      }\n\n      h1 {\n        font-size: 1.5em;\n      }\n\n      h2 {\n        font-size: 1.3em;\n      }\n\n      h3 {\n        font-size: 1.1em;\n      }\n\n    }\n\n    pre.CodeMirror-line {\n      line-height: 1.5em !important; \n    }\n\n    .CodeMirror-scroll {\n      max-height: 500px;\n      overflow-y: auto;\n    }\n\n    .CodeMirror-fullscreen {\n      .CodeMirror-scroll {\n        max-height: calc(100vh - 54px);\n      }\n    }\n\n    .CodeMirror {\n      border-color: ", ";\n      border-radius: 0 !important; \n      line-height: 1.5em;\n\n      .cm-header {\n        margin-bottom: 0.5em;\n        display: inline-block;\n        line-height: 1.35em;\n        font-weight: 500;\n        color: ", ";\n      }\n\n      .cm-header-1,\n      .cm-header-2,\n      .cm-header-3 {\n      }\n\n      .cm-header-1 {\n        font-size: 1.5em;\n      }\n\n      .cm-header-2 {\n        font-size: 1.3em;\n      }\n\n      .cm-header-3 {\n        font-size: 1.1em;\n      }\n\n      img {\n        max-width: 100%;\n      }\n    }\n  "], ["\n\n    position: relative;\n\n    ", "\n\n    &:focus-within {\n      .CodeMirror-wrap {\n        border-color: ", ";\n      }\n\n    }\n    .editor-statusbar {\n      border: 1px solid #DDD;\n      border-top: 0;\n      background: #F9F9F9;\n    }\n\n    .editor-preview-side {\n      z-index: 200;\n      border-right: none;\n      border-left-color: #D2D2D2;\n      border-top-color: #D2D2D2;\n    }\n\n    .editor-toolbar.fullscreen {\n      z-index: 200;\n      padding: ", " ", " 0 ", ";\n      background: ", ";\n    }\n\n    .editor-toolbar {\n      border: none;\n      padding: 0;\n      margin-bottom: 4px;\n      &:before {\n        margin-bottom: 0px;\n        height: 0;\n      }\n\n      button {\n        border-radius: 0;\n      }\n      \n      button.active,\n      button.hover,\n      button:focus,\n      button:active { \n        border-color: ", ";\n        outline-color: ", ";\n      }\n\n      &.disabled-for-preview {\n        button {\n          opacity: 0.1;\n        }\n\n        button.preview, button.guide {\n          opacity: 1.0;\n        }\n      }\n    }\n\n    .editor-preview {\n      padding: 14px;\n      line-height: 1.5em;\n      a {\n        color: ", ";\n        font-weight: 400;\n        text-decoration: none;\n      }\n\n      h1, h2, h3, h4, h5 {\n        margin-top: 0em;\n        margin-bottom: 0.5em;\n        line-height: 1.35em;\n        font-weight: 500;\n        color: ", ";\n      }\n\n      h1 {\n        font-size: 1.5em;\n      }\n\n      h2 {\n        font-size: 1.3em;\n      }\n\n      h3 {\n        font-size: 1.1em;\n      }\n\n    }\n\n    pre.CodeMirror-line {\n      line-height: 1.5em !important; \n    }\n\n    .CodeMirror-scroll {\n      max-height: 500px;\n      overflow-y: auto;\n    }\n\n    .CodeMirror-fullscreen {\n      .CodeMirror-scroll {\n        max-height: calc(100vh - 54px);\n      }\n    }\n\n    .CodeMirror {\n      border-color: ", ";\n      border-radius: 0 !important; \n      line-height: 1.5em;\n\n      .cm-header {\n        margin-bottom: 0.5em;\n        display: inline-block;\n        line-height: 1.35em;\n        font-weight: 500;\n        color: ", ";\n      }\n\n      .cm-header-1,\n      .cm-header-2,\n      .cm-header-3 {\n      }\n\n      .cm-header-1 {\n        font-size: 1.5em;\n      }\n\n      .cm-header-2 {\n        font-size: 1.3em;\n      }\n\n      .cm-header-3 {\n        font-size: 1.1em;\n      }\n\n      img {\n        max-width: 100%;\n      }\n    }\n  "])), function (props) {
    return !props._maxWidth && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      max-width: ", ";\n    "], ["\n      max-width: ", ";\n    "])), props._maxWidth);
  }, theme_1.theme.COLOR('primary'), theme_1.theme.UNIT(2.5), theme_1.theme.UNIT(1.5), theme_1.theme.UNIT(1.5), theme_1.theme.COLOR('app-chrome'), theme_1.theme.COLOR('primary'), theme_1.theme.COLOR('primary'), theme_1.theme.COLOR('primary'), theme_1.theme.COLOR('dark'), theme_1.theme.COLOR('line-mid'), theme_1.theme.COLOR('dark'))
});
var EditorStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    position: absolute;\n    bottom: ", ";\n    left: ", ";\n  "], ["\n    position: absolute;\n    bottom: ", ";\n    left: ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(3, 2))
});
var GenerateButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-size: ", ";\n    color: ", ";\n    ", ";\n    font-weight: 500;\n    cursor: pointer;\n\n    &:hover {\n      color: ", ";\n      ", ";\n    }\n\n  "], ["\n    font-size: ", ";\n    color: ", ";\n    ", ";\n    font-weight: 500;\n    cursor: pointer;\n\n    &:hover {\n      color: ", ";\n      ", ";\n    }\n\n  "])), theme_1.theme.FONT_SIZE(13), theme_1.theme.COLOR('primary'), theme_1.theme.FILL('primary'), theme_1.theme.COLOR('dark'), theme_1.theme.FILL('dark'))
});
var ImageModalStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    .shp--form-tabs {\n      display: none;\n    }\n  "], ["\n    .shp--form-tabs {\n      display: none;\n    }\n  "])))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(field_container_1.FieldContainer)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  EditorContainer: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), EditorContainerStyles),
  Editor: react_simplemde_editor_1.default,
  Controls: styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles),
  GenerateButton: (0, styled_components_1.default)(icon_label_1.IconLabel)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), GenerateButtonStyles),
  ImageModal: (0, styled_components_1.default)(entity_modal_form_route_1.EntityModalCreateFormRoute)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ImageModalStyles)
};
var InputMarkdownEditorComponent = function (props) {
  var className = props.className,
    field = props.field,
    onChange = props.onChange,
    options = props.options,
    entityName = props.entityName,
    entityTypeName = props.entityTypeName;
  var entities = (0, use_entities_1.useEntities)();
  var modal = (0, use_modal_1.useModal)();
  var _a = __read(React.useState(), 2),
    editor = _a[0],
    setEditor = _a[1];
  var t = (0, use_lang_1.useLang)();
  var toolbar = ['preview', 'side-by-side', 'fullscreen', '|', 'bold', 'italic', '|', {
    name: 'insert-image-entity',
    className: 'fa fa-image',
    action: function (editor) {
      var cm = editor.codemirror;
      var output = '';
      var selectedText = cm.getSelection();
      modal.show(React.createElement(My.ImageModal, {
        metadata: {
          variant: 'simple'
        },
        onSubmit: function (entity) {
          if (selectedText) {
            output = "<".concat(entity.__typename, " id=\"").concat(entity.id, "\">").concat(selectedText, "</").concat(entity.__typename, ">");
          } else {
            output = "\r\n<".concat(entity.__typename, " id=\"").concat(entity.id, "\" />\r\n");
          }
          cm.replaceSelection(output);
          cm.focus();
          modal.hide();
        },
        onCancel: function () {
          return modal.hide();
        },
        definition: entities.ImageAsset
      }));
    }
  }, {
    name: "insert-link",
    className: "icon icon-LinkGlyph",
    // Look for a suitable icon
    action: function (editor) {
      var cm = editor.codemirror;
      var output = '';
      var selectedText = cm.getSelection();
      modal.show(React.createElement(link_dialog_1.LinkDialog, {
        text: selectedText,
        onCancel: function () {
          cm.focus();
          modal.hide();
        },
        onConfirm: function (url, text) {
          output = "[".concat(text || '', "](").concat(url, ")");
          cm.replaceSelection(output);
          cm.focus();
          modal.hide();
        }
      }));
    },
    label: "Link",
    title: "Insert Link"
  }, {
    name: "insert-entity",
    className: "icon icon-Entity",
    // Look for a suitable icon
    action: function (editor) {
      var cm = editor.codemirror;
      var output = '';
      var selectedText = cm.getSelection();
      modal.show(React.createElement(entity_embed_dialog_1.EntityEmbedDialog, {
        onCancel: function () {
          cm.focus();
          modal.hide();
        },
        onConfirm: function (value) {
          if (selectedText) {
            output = "<".concat(value.__typename, " slug=\"").concat(value.slug, "\" id=\"").concat(value.id, "\">").concat(selectedText, "</").concat(value.__typename, ">");
          } else {
            output = "\n\n<".concat(value.__typename, " slug=\"").concat(value.slug, "\" id=\"").concat(value.id, "\" />\n\n");
          }
          cm.replaceSelection(output);
          cm.focus();
          modal.hide();
        }
      }));
    },
    label: "Embed",
    title: "Embed Platform Item"
  }, '|', 'heading-1', 'heading-2', 'heading-3', '|', 'unordered-list', 'ordered-list', 'quote', '|', 'horizontal-rule', '|', 'guide'];
  if (!field) {
    throw new Error('InputMarkdownEditor requires a field specification.');
  }
  var value = field.value,
    placeholder = field.placeholder,
    name = field.name,
    valid = field.valid,
    focus = field.focus,
    useCompletions = field.useCompletions;
  var handleChange = function (v) {
    onChange({
      name: name,
      value: v
    });
  };
  var usePlaceholder = valid ? placeholder || '' : '';
  var fieldProps = __assign(__assign({}, field), {
    errorMessage: !valid ? placeholder : ''
  });
  var opts = __assign(__assign({}, options), {
    placeholder: field.placeholder,
    autofocus: focus,
    toolbar: toolbar,
    indentWithTabs: false,
    minHeight: field.minHeight || field.height || options.minHeight,
    syncSideBySidePreviewScroll: false
  });
  var getInstance = function (instance) {
    if (focus) {
      setTimeout(function () {
        if (instance.codemirror && instance.codemirror.focus) {
          instance.codemirror.focus();
        }
      }, 100);
    }
  };
  var onGenerateClick = React.useCallback(function () {
    modal.show(React.createElement(entity_completion_dialog_1.EntityCompletionDialog, {
      entityTypeName: entityTypeName,
      entityName: entityName,
      onCancel: function () {
        modal.hide();
      },
      onConfirm: function (text) {
        handleChange(text);
        modal.hide();
      }
    }));
  }, [entityTypeName, entityName]);
  return React.createElement(My.Container, {
    field: fieldProps,
    className: className
  }, React.createElement(My.EditorContainer, {
    _maxWidth: field.maxWidth,
    valid: valid
  }, React.createElement(My.Editor, {
    getMdeInstance: getInstance,
    id: (0, form_field_id_1.formFieldId)(field),
    onChange: handleChange,
    value: value,
    options: opts
  }), React.createElement(My.Controls, null, useCompletions && !!entityName && entityTypeName && React.createElement(My.GenerateButton, {
    onClick: onGenerateClick,
    size: 'small',
    icon: React.createElement(icons_1.Icons.OpenAI, null)
  }, t('Generate via OpenAI')))));
};
exports.InputMarkdownEditorComponent = InputMarkdownEditorComponent;
exports.InputMarkdownEditor = (0, styled_components_1.withTheme)(exports.InputMarkdownEditorComponent);
exports.InputMarkdownEditor.defaultProps = exports.InputMarkdownEditorDefaultProps;
var createInputMarkdownEditor = function (props) {
  return React.createElement(exports.InputMarkdownEditor, __assign({}, props));
};
exports.createInputMarkdownEditor = createInputMarkdownEditor;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;